import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  template: `
    <div class="main-container">
      <h2>{{error}}</h2>
    </div>
  `
})
export class PageNotFoundComponent {
  public error = '';

  constructor(
    private location: Location,
  ){
    this.error = location.path() === '/forbidden' ? 'Forbidden' : 'Page not found';
  }

}
